const clientName = window.clientName;
const serverApi = window.serverApi;
const isDevelopment = window.isDevelopment;
const isLocalDev = window.staticUrl?.includes("localhost");
const isStaging = window.isStaging;
const isProduction = window.isProduction;
const isOfflinePlayer = window.isOfflinePlayer;
const enableTestingApi = window.enableTestingApi;
// Combo of a commit hash and the build number.
const buildVersion = window.buildVersion ?? "dev";
// Circle ci build number in sequential order.
const buildNumber =
    buildVersion !== "dev"
        ? parseInt(window.buildVersion.split("-")[1])
        : Number.POSITIVE_INFINITY;

const serverContext = window.serverContext ?? {};
const electronAppVersion = window.electronAppVersion ?? null;
const pusherKey = window.pusherKey;
const pusherCluster = window.pusherCluster;
const isPPTAddin = window.isPPTAddin ?? false;
const isZoomApp = window.isZoomApp ?? false;
const isDropboxEnabled = !!window.Dropbox;
// Related to rendering a thumnail
const isRenderer = window.isRenderer ?? false;
const appVersion = window.appVersion;
const isCypress = !!window.Cypress;
const disablePusher = window.disablePusher ?? false;
const serverUrl = window.serverUrl;
const isStorybook = window.isStorybook ?? false;
const isOpenaiApp = window.isOpenaiApp ?? false;
const HUBSPOT_SCRIPT_URL = "https://js-na2.hsforms.net/forms/embed/242561727.js";
const HUBSPOT_SCRIPT_ID = "hubspot-form-embed-script";
const HUBSPOT_REGION = "na2";
const HUBSPOT_PORTAL_ID = "242561727";
const HUBSPOT_ENTERPRISE_FORM_ID = "2a23c847-d0ce-4793-9b04-92e76fe40aff";
const REVENUEHERO_SCRIPT_URL = "https://assets.revenuehero.io/scheduler.min.js";
const REVENUEHERO_SCRIPT_ID = "revenuehero-scheduler-script";
const REVENUEHERO_ROUTER_ID = "4482";
const initialPath = window.initialPath;
const publicWorkspaces = window.publicWorkspaces ?? { presentationTemplates: null };
const releaseVersion = window.releaseVersion;

function isInternalBAIUser(email) {
    return email?.endsWith("@beautiful.ai");
}

function getStaticUrl(path, isAbsolute) {
    if (window.staticUrl) {
        if (window.manifest[path]) {
            if (isAbsolute && window.manifest[path].startsWith("http")) {
                return window.manifest[path];
            } else {
                return window.staticUrl + window.manifest[path];
            }
        }
        return window.staticUrl + path;
    } else {
        return path;
    }
}

export {
    clientName,
    serverApi,
    serverUrl,
    serverContext,
    isDevelopment,
    isLocalDev,
    isStaging,
    isProduction,
    isOfflinePlayer,
    isRenderer,
    enableTestingApi,
    electronAppVersion,
    buildVersion,
    buildNumber,
    getStaticUrl,
    isInternalBAIUser,
    pusherKey,
    pusherCluster,
    isPPTAddin,
    isZoomApp,
    isDropboxEnabled,
    appVersion,
    isCypress,
    disablePusher,
    isStorybook,
    isOpenaiApp,
    HUBSPOT_SCRIPT_URL,
    HUBSPOT_SCRIPT_ID,
    HUBSPOT_REGION,
    HUBSPOT_PORTAL_ID,
    HUBSPOT_ENTERPRISE_FORM_ID,
    REVENUEHERO_SCRIPT_URL,
    REVENUEHERO_SCRIPT_ID,
    REVENUEHERO_ROUTER_ID,
    initialPath,
    publicWorkspaces,
    releaseVersion,
};
